module.exports = __webpack_public_path__ + "img/myBijuleeBanner.e341a547.jpg";